// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsClsInboundPrescription {
    'preferedPharmacy'?: string | null;
    'cartridgePenNeedleGauge'?: string | null;
    'forVial'?: string | null;
    'syringeNeedleGauge'?: string | null;
    'ancillarySuppliesDaysSupply'?: number;
    'rxDispenseType'?: string | null;
    'startDate'?: string | null;
    'rxSignatureFlag'?: string | null;
    'daysSupply'?: number;
    'product'?: string | null;
    'rxDosingDirections'?: string | null;
    'requestedQuantity'?: number;
    'refills'?: number;
    'rxSignatureDate'?: string | null;
    'primarydiagnosisName'?: string | null;
    'primaryicdCode'?: string | null;
    'secondarydiagnosisName'?: string | null;
    'secondaryicdCode'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsClsInboundPrescription>> = [
        {
            "name":     "preferedPharmacy",
            "baseName": "preferedPharmacy",
            "type":     "string"
        },
        {
            "name":     "cartridgePenNeedleGauge",
            "baseName": "cartridgePenNeedleGauge",
            "type":     "string"
        },
        {
            "name":     "forVial",
            "baseName": "forVial",
            "type":     "string"
        },
        {
            "name":     "syringeNeedleGauge",
            "baseName": "syringeNeedleGauge",
            "type":     "string"
        },
        {
            "name":     "ancillarySuppliesDaysSupply",
            "baseName": "ancillarySuppliesDaysSupply",
            "type":     "number"
        },
        {
            "name":     "rxDispenseType",
            "baseName": "rxDispenseType",
            "type":     "string"
        },
        {
            "name":     "startDate",
            "baseName": "startDate",
            "type":     "string"
        },
        {
            "name":     "rxSignatureFlag",
            "baseName": "rxSignatureFlag",
            "type":     "string"
        },
        {
            "name":     "daysSupply",
            "baseName": "daysSupply",
            "type":     "number"
        },
        {
            "name":     "product",
            "baseName": "product",
            "type":     "string"
        },
        {
            "name":     "rxDosingDirections",
            "baseName": "rxDosingDirections",
            "type":     "string"
        },
        {
            "name":     "requestedQuantity",
            "baseName": "requestedQuantity",
            "type":     "number"
        },
        {
            "name":     "refills",
            "baseName": "refills",
            "type":     "number"
        },
        {
            "name":     "rxSignatureDate",
            "baseName": "rxSignatureDate",
            "type":     "string"
        },
        {
            "name":     "primarydiagnosisName",
            "baseName": "primarydiagnosisName",
            "type":     "string"
        },
        {
            "name":     "primaryicdCode",
            "baseName": "primaryicdCode",
            "type":     "string"
        },
        {
            "name":     "secondarydiagnosisName",
            "baseName": "secondarydiagnosisName",
            "type":     "string"
        },
        {
            "name":     "secondaryicdCode",
            "baseName": "secondaryicdCode",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsClsInboundPrescription.attributeTypeMap;
    }
}
